import React from "react";
import BoxContainer from "../BoxContainer";
import Text from "../Text";
import textResolver from "../../core/utils/text-resolver";
import iconResolver from "../../core/icon-resolver";

function ThreeCol({ data, background = "bg-circleGradient bg-cover" }) {
  const { dataType = 0 } = data;

  return (
    <BoxContainer background={background} className="xs:px-5 2xl:px-0 py-24">
      <div className="max-w-6xl mx-auto">
        <div className="max-w-4xl mx-auto pb-14">
          <Text
            as="h2"
            className="text-5xl text-blue text-center font-primary font-bold pb-7"
          >
            {dataType === 1 ? data.title : textResolver(data, "title")}
          </Text>
          <Text
            as="p"
            className="text-lg leading-8 text-blue text-center font-opensans"
          >
            {dataType === 1 ? data.subtitle : textResolver(data, "subtitle")}
          </Text>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-14 items-baseline">
          {data.items.map((item, i) => {
            return (
              <div key={i}>
                {iconResolver(
                  dataType === 1 ? item.icon : textResolver(item, "icon")
                )}
                <div className="pt-5">
                  <Text
                    as="h3"
                    className="text-26px leading-[36px] text-blue font-primary font-semibold md:min-h-xl xl:min-h-[7rem] mb-6"
                  >
                    {dataType === 1
                      ? item.heading
                      : textResolver(item, "heading")}
                  </Text>
                  <Text as="p" className="text-base font-opensans text-blue">
                    {dataType === 1
                      ? item.description
                      : textResolver(item, "description")}
                  </Text>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </BoxContainer>
  );
}
export default ThreeCol;
